import { ServerService } from '../services/ServerService';
import { Module } from '../Module';

export interface IPostLoginNotificationCtrlScope extends ng.IScope {
  showNotificationAgain: boolean;
  toggleShowNotificationAgain: () => void;
  resourceLocationUrl: string;
  uriQueryJsonString: string;
}

export class PostLoginNotificationCtrl {
  public static $inject = [
    '$scope'
  ];

  constructor(
    $scope: IPostLoginNotificationCtrlScope,
  ) {
    $scope.toggleShowNotificationAgain = () => {
      let url = $scope.resourceLocationUrl;
      if ($scope.showNotificationAgain) {
        // switch "showNotificationAgain" from true to false, and remove the cached url
        $scope.showNotificationAgain = false;
        let value = localStorage.getItem(url);
        if (value != null) {
          localStorage.removeItem(url);
        }
      } else {
        // switch "showNotificationAgain" from false to true, and cache the timestamp
        $scope.showNotificationAgain = true;
        localStorage.setItem(url, $scope.uriQueryJsonString);
      }
    };

    $scope.showNotificationAgain = false;
  }
}

Module.instance().controller('PostLoginNotificationCtrl', PostLoginNotificationCtrl);